import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
;

@Component({
  selector: 'app-print-table',
  templateUrl: './print-table.component.html',
  styleUrls: ['./print-table.component.scss']
})
export class PrintTableComponent implements OnInit {
  @ViewChildren('printText') printTextElements!: QueryList<ElementRef>;
  data: any;
  modalWindow: string;
  year: number = new Date().getFullYear();
  currentDate: string = new Date().toLocaleDateString();
  textPadding: number[] = [];
  sessionNumber: number;
  topic: string;
  useCase: string;
  coach: string;
  dateComplection: string;
  preferedLanguage: string;
  coachee: string;
  company: string;


  constructor(private route: ActivatedRoute,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.modalWindow = params['modalWindow'];
      this.sessionNumber = params['session'];
      this.topic = params['topic'];
      this.useCase = params['useCase'];
      this.coach = params['coach'];
      this.coachee = params['coachee'];
      this.company = params['company'];
      this.dateComplection = params['date'];
      this.data = JSON.parse(params['data']);
      this.preferedLanguage = params['preferredLanguage'];
      let language =  params['language'] === 'english' ? 'en' : 'de';
      this.translate.use(language);
    });

    setTimeout(() => {
      window.print();
    }, 500);
  }

  ngAfterViewInit() {
    this.printTextElements.forEach((element, index) => {
      const height = element.nativeElement.offsetHeight;
      this.textPadding[index] = height < 20 ? 20 : 0;
    });
  }
}
